import { render } from "./BaseMobileOptionsWrapper.vue?vue&type=template&id=99f2a174&scoped=true"
const script = {}

import "./BaseMobileOptionsWrapper.vue?vue&type=style&index=0&id=99f2a174&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99f2a174"]])

export default __exports__